module.exports = "../content/3cdce7329000e8ce9c861d5658c78300.woff2";